import { render, staticRenderFns } from "./processform.vue?vue&type=template&id=56f5e18b&scoped=true"
import script from "./processform.vue?vue&type=script&lang=js"
export * from "./processform.vue?vue&type=script&lang=js"
import style0 from "./processform.vue?vue&type=style&index=0&id=56f5e18b&prod&lang=scss&scoped=true"
import style1 from "./processform.vue?vue&type=style&index=1&id=56f5e18b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5e18b",
  null
  
)

export default component.exports